import React, { useState } from "react";
import {
  Modal,
  Form,
  Button,
  ProgressBar,
  Container,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import BrandWhite from "../../assets/72.svg";
import { Link, useNavigate } from "react-router-dom";
import { useModal } from "../../context/ModalContext";
import axios from "axios";

import countries from "../../data/countries.json";
import states from "../../data/states.json";
import { useAPI } from "../../hooks/useAPI";

const NewLead = () => {
  const { api } = useAPI();
  const { isModalOpen, closeModal } = useModal();
  const [error, setError] = useState();
  const [filteredStates, setFilteredStates] = useState([]);
  const navigate = useNavigate();

  // State to track the current step
  const [step, setStep] = useState(1);
  // State to store form data
  const [formData, setFormData] = useState({
    fleetSize: "",
    interestedIn: [],
    country: {},
    state: "",
    company: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    code: "",
    vehicles: {
      available: false,
      qty: 0,
    },
    assets: {
      available: false,
      qty: 0,
    },
  });

  const getStatesByCountryId = (countryId) => {
    return states[2].data.filter((state) => state.countryId === countryId);
  };

  const handleCountryChange = (e) => {
    const selectedCountry = countries[2].data.find(
      (country) => country.id === e.target.value
    );
    console.log("Selected Country:", selectedCountry);
    setFormData({ ...formData, country: selectedCountry, state: "" });
    setFilteredStates(getStatesByCountryId(selectedCountry?.id));
    console.log(formData.country.name);
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // if(e.target.type === 'radio') {
    //     toggleBackground(e);
    //     console.log("Radio:", e);
    // }
    console.log(formData);
  };

  const handleSendOTP = async () => {
    try {
      const res = await api.post('/api/leads/send-code', {email: formData?.email});
      if (res.status === 200) {
        setStep(8);
      };
    } catch (err) {
      console.log("Error sending verification code", err);
    }
  }

  // Navigation functions
  const nextStep = () => {
    console.log("Current Step: ", step);
    if (step === 7) {
      console.log("Next step: ", step +1);
     handleSendOTP();

    } else if (step < 7) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/api/leads", formData);
      console.log("Lead submitted successfully:", response.data);
      navigate("/thank-you");
      setStep(1);
      setFormData({
        fleetSize: "",
        interestedIn: [],
        country: {},
        state: "",
        company: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        code: "",
        vehicles: {
          available: false,
          qty: 0,
        },
        assets: {
          available: false,
          qty: 0,
        },
      });
      closeModal();
    } catch (error) {
      console.error("Error submitting lead:", error);
      // Handle error (show error message to user)
      setError(error?.response.data?.message);
    }
  };

  // Progress bar based on step
  const progressPercentage = (step / 8) * 100;

  function toggleBackground(e) {
    const checkbox = e.target; // Access the checkbox element
    const container = checkbox.closest(".input-container"); // Find the parent container
    console.log("Background", e);
    if (container) {
      if (checkbox.checked) {
        container.style.backgroundColor = "rgba(255, 255, 0, 0.148)";
        container.style.outline = "3px solid var(--accent-color)";
      } else {
        container.style.backgroundColor = "unset";
        container.style.outline = "2px solid rgba(255, 255, 0, 0.167)";
      }
    } else {
      console.error("No parent container found for the checkbox.");
    }
  }

  const [instrestedInCheck, setInstrestedInCheck] = useState({
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option6: false,
  });

  const handleChangeCheckbox = (e) => {
    const checkbox = e.target;
    if (checkbox.checked) {
      setFormData((prevData) => {
        const newInterestedIn = [...prevData.interestedIn];
        newInterestedIn.push(checkbox.value);
        return {
          ...prevData,
          interestedIn: newInterestedIn,
        };
      });
    }
    setInstrestedInCheck((prevCheck) => {
      const newCheck = { ...prevCheck };
      newCheck[checkbox.value] = checkbox.checked;
      return {
        ...prevCheck,
        [checkbox.id]: checkbox.checked,
      };
    });
    console.log({ instrestedInCheck });
    toggleBackground(e);
  };

  const handleChangeQtyCheckbox = (e) => {
    const name = e.target.getAttribute("name"); // Get the name (e.g., 'vehicles' or 'assets')
    setFormData((prevData) => ({
      ...prevData,
      [name]: {
        available: e.target.checked, // Update the availability status for the specified field
        qty: e.target.checked ? 1 : 0, // Set the qty to 1 if the checkbox is checked, otherwise 0
      },
    }));
    toggleBackground(e);
  };

  const handleAddQty = (e) => {
    const name = e.currentTarget.getAttribute("name"); // Get the name (e.g., 'vehicles' or 'assets')
    setFormData((prevData) => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        qty: prevData[name].qty + 1, // Increment the qty for the specified field
      },
    }));
  };

  const handleRemoveQty = (e) => {
    const name = e.currentTarget.getAttribute("name"); // Get the name (e.g., 'vehicles' or 'assets')
    setFormData((prevData) => {
      const newQty = prevData[name].qty - 1;
      if (newQty >= 0) {
        return {
          ...prevData,
          [name]: {
            ...prevData[name],
            qty: newQty, // Decrement the qty for the specified field
          },
        };
      } else {
        // alert("Quantity cannot be less than 0.");
        return prevData; // Prevent the update
      }
    });
  };

  const handleCounterInputChange = (e) => {
    const { name, value } = e.target;
    const qty = parseInt(value, 10);

    if (!isNaN(qty) && qty >= 0) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: {
          ...prevData[name],
          qty, // Update qty with the manually entered value
        },
      }));
    } else {
      alert("Please enter a valid quantity.");
    }
  };

  return (
    <>
      <Modal show={isModalOpen} fullscreen onHide={closeModal}>
        <Modal.Header closeButton className="px-5">
          <Modal.Title>
            <div className="brand">
              <Link to="/">
                <img src={BrandWhite} alt="Shoora" width={180} />
              </Link>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5 pt-0 mt-0">
          <div className="row justify-content-center">
            <div className="col col-12 col-md-4">
              <ProgressBar
                now={progressPercentage}
                variant="warning"
                className="mb-4"
                style={{ height: "5px" }}
              />
              {step === 1 && (
                <div>
                  <h3 className="fw-bold">
                    Let's get started. <br />
                    To tailor the right solution for you, could you tell us: How
                    many vehicles are currently in your fleet?
                  </h3>
                  <div className="form-group">
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option1"
                          value="1"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "1"}
                          required
                        />
                        <label className="form-check-label" htmlFor="option1">
                          1
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option2-4"
                          value="2-4"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "2-4"}
                          required
                        />
                        <label className="form-check-label" htmlFor="option2-4">
                          2-4
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option5-15"
                          value="5-15"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "5-15"}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="option5-15"
                        >
                          5-15
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option16-49"
                          value="16-49"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "16-49"}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="option16-49"
                        >
                          16-49
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option50-149"
                          value="50-149"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "50-149"}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="option50-149"
                        >
                          50-149
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option150-399"
                          value="150-399"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "150-399"}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="option150-399"
                        >
                          150-399
                        </label>
                      </div>
                    </div>
                    <div className="input-container">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="fleetSize"
                          id="option400+"
                          value="400+"
                          onChange={handleInputChange}
                          checked={formData.fleetSize === "400+"}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="option400+"
                        >
                          400+
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {step === 2 && (
                <div>
                  <h3 className="fw-bold mb-3">
                    Awesome. Now, to help us match the best tools for your
                    needs: What features are you most interested in?
                  </h3>
                  <div className="input-container">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={instrestedInCheck.option1}
                        value="Real-time tracking"
                        name="interestedIn"
                        id="option1"
                        onChange={handleChangeCheckbox}
                      />
                      <label className="form-check-label w-100" for="option1">
                        Real-time tracking
                      </label>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Driver Status Monitoring (DSM)"
                        id="option2"
                        onChange={handleChangeCheckbox}
                      />
                      <label className="form-check-label w-100" for="option2">
                        Driver Status Monitoring (DSM)
                      </label>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="ADAS"
                        id="option3"
                        onChange={handleChangeCheckbox}
                      />
                      <label className="form-check-label w-100" for="option3">
                        ADAS
                      </label>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Fuel monitoring"
                        id="option4"
                        onChange={handleChangeCheckbox}
                      />
                      <label className="form-check-label w-100" for="option4">
                        Fuel monitoring
                      </label>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="Fleet Management"
                        id="option5"
                        onChange={handleChangeCheckbox}
                      />
                      <label className="form-check-label w-100" for="option5">
                        Fleet Management
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div>
                  <h3 className="fw-bold mb-3">
                    Great! Could you share where you're located?
                  </h3>
                  <Form.Group controlId="country" className="mb-3">
                    <Form.Label className="fw-bold">Country</Form.Label>
                    <Form.Select
                      name="country"
                      value={formData.country.id}
                      onChange={handleCountryChange}
                      required
                      size="lg"
                    >
                      <option value="">Select Country</option>
                      {countries[2]?.data?.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group controlId="state">
                    <Form.Label className="fw-bold">State</Form.Label>
                    <Form.Select
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      required
                      size="lg"
                    >
                      <option value="">Select State</option>
                      {filteredStates?.map((state) => (
                        <option key={state.id} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              )}

              {step === 4 && (
                <div>
                  <h3 className="fw-bold mb-3">
                  Perfect, and which company are you with?
                  </h3>
                  <Form.Group controlId="company">
                    <Form.Label className="fw-bold">Company</Form.Label>
                    <Form.Control
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      required
                      size="lg"
                    />
                  </Form.Group>
                </div>
              )}
              {step === 5 && (
                <div>
                  <h3 className="fw-bold mb-3">What's your name?</h3>
                  <div className="d-flex gap-3">
                    <Form.Group controlId="firstName">
                      <Form.Label className="fw-bold">First name</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required
                        size="lg"
                      />
                    </Form.Group>
                    <Form.Group controlId="lastName">
                      <Form.Label className="fw-bold">Last name</Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required
                        size="lg"
                      />
                    </Form.Group>
                  </div>
                </div>
              )}
              {step === 6 && (
                <div>
                  <h3 className="fw-bold mb-3">
                    Let's continue {formData.firstName}, where should we send
                    your information?
                  </h3>
                  <Form.Group controlId="email">
                    <Form.Label className="fw-bold">Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      size="lg"
                    />
                  </Form.Group>
                </div>
              )}
              {step === 7 && (
                <div>
                  <h3 className="fw-bold mb-3">
                  Finally, could you share the phone number to reach you at?
                  </h3>
                  <Form.Group controlId="phone">
                    <Form.Label className="fw-bold">Phone number</Form.Label>
                    <Form.Control
                      type="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      size="lg"
                    />
                  </Form.Group>
                </div>
              )}
              {step === 8 && (
                // <div>
                //   <h3 className="fw-bold mb-3">
                //     Thanks, {formData.firstName}.
                //   </h3>
                //   <p>
                //     To provide you with the best possible demo, please confirm
                //     the number of vehicles and assets in your fleet.
                //   </p>

                //   <div className="input-container d-flex justify-content-between">
                //     <div className="form-check d-flex gap-2 align-items-center">
                //       <input
                //         className="form-check-input"
                //         type="checkbox"
                //         id="vehicles"
                //         name="vehicles"
                //         // checked={formData.vehicles.available}
                //         onChange={handleChangeQtyCheckbox}
                //       />
                //       <label
                //         className="form-check-label d-flex align-items-center w-100 justify-content-between"
                //         htmlFor="vehicles"
                //       >
                //         Vehicles
                //       </label>
                //     </div>
                //     <span className="flex-right counter-input-group">
                //       <div className="input-group input-group-sm rounded-4">
                //         <button
                //           className="btn btn-accent"
                //           type="button"
                //           id="button-addon1"
                //           onClick={handleRemoveQty}
                //           name="vehicles"
                //           disabled={!formData.vehicles.available}
                //         >
                //           <i className="fa-solid fa-minus"></i>
                //         </button>
                //         <input
                //           type="text"
                //           className="form-control text-center fw-bold rounded-5"
                //           name="vehicles"
                //           value={formData.vehicles.qty}
                //           style={{ width: "50px" }}
                //           placeholder=""
                //           aria-label="Example text with button addon"
                //           aria-describedby="button-addon1"
                //           onChange={handleCounterInputChange}
                //           disabled={!formData.vehicles.available}
                //         />
                //         <button
                //           className="btn btn-accent"
                //           type="button"
                //           id="button-addon1"
                //           onClick={handleAddQty}
                //           name="vehicles"
                //           disabled={!formData.vehicles.available}
                //         >
                //           <i className="fa-solid fa-plus"></i>
                //         </button>
                //       </div>
                //     </span>
                //   </div>

                //   <div className="input-container d-flex justify-content-between">
                //     <div className="form-check">
                //       <input
                //         className="form-check-input"
                //         type="checkbox"
                //         value=""
                //         id="assets"
                //         name="assets"
                //         checked={formData.assets.available}
                //         onChange={handleChangeQtyCheckbox}
                //       />
                //       <label className="form-check-label w-100" for="assets">
                //         Assets
                //       </label>
                //     </div>
                //     <span className="flex-right counter-input-group">
                //       <div className="input-group input-group-sm rounded-4">
                //         <button
                //           className="btn btn-accent"
                //           type="button"
                //           id="button-addon1"
                //           onClick={handleRemoveQty}
                //           name="assets"
                //           disabled={!formData.assets.available}
                //         >
                //           <i className="fa-solid fa-minus"></i>
                //         </button>
                //         <input
                //           type="text"
                //           className="form-control text-center fw-bold rounded-5"
                //           name="assets"
                //           value={formData.assets.qty}
                //           style={{ width: "50px" }}
                //           placeholder=""
                //           aria-label="Example text with button addon"
                //           aria-describedby="button-addon1"
                //           onChange={handleCounterInputChange}
                //           disabled={!formData.assets.available}
                //         />
                //         <button
                //           className="btn btn-accent"
                //           type="button"
                //           id="button-addon1"
                //           onClick={handleAddQty}
                //           name="assets"
                //           disabled={!formData.assets.available}
                //         >
                //           <i className="fa-solid fa-plus"></i>
                //         </button>
                //       </div>
                //     </span>
                //   </div>
                // </div>
                <div>
                  <h3 className="fw-bold mb-3">
                    Thanks, {formData.firstName}.
                  </h3>
                  <p>
                    To confirm that you are not a robot, we have sent you a confirmation code to {formData?.email}.
                  </p>

                 <Form.Group controlId="code">
                    <Form.Label className="fw-bold">Verification Code</Form.Label>
                    <Form.Control
                      type="code"
                      name="code"
                      value={formData.code}
                      onChange={handleInputChange}
                      required
                      size="lg"
                    />
                  </Form.Group>
                </div>
              )}

              <Row className="mt-4">
                {step < 8 ? (
                  <button
                    type="button"
                    onClick={nextStep}
                    disabled={
                      (step == 1 && formData.fleetSize == "") ||
                      (step == 2 && formData.interestedIn?.length == 0) ||
                      (step == 3 && formData.state == "") ||
                      (step == 4 && formData.company == "") ||
                      (step == 5 &&
                       ( formData.firstName == "" &&
                        formData.lastName == "")) ||
                      (step == 6 && formData.email == "") ||
                      (step == 7 && formData.phone == "")
                    }
                    className="btn btn-dark rounded-5 fs-5 p-2"
                  >
                    Continue
                  </button>
                ) : (
                  <button
                    className="btn btn-success rounded-5 fs-5 p-2"
                    onClick={handleSubmit}
                  >
                    Verify
                  </button>
                )}

                <button
                  className="btn btn-link text-dark text-decoration-none"
                  onClick={prevStep}
                  disabled={step === 1}
                >
                  Previous
                </button>

                {error && (
                  <Alert variant="danger" style={{ marginTop: 3 }}>
                    {error}
                  </Alert>
                )}
              </Row>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewLead;
